export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Employers', to: '/employers' },
  { label: 'Career Opportunities', to: '/candidates' },
  { label: 'Contact Us', to: '/contact' },
];

export const contactEmail = 'info@risingtalentpartners.com';
export const websiteUrl = 'https://risingtalentpartners.com';
